import classnames from 'classnames';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  LaunchEntryStatusIcon,
  LaunchSequenceStepStatus,
} from './LaunchSequenceStatusIcon';

type Props = {
  step: GraphQLTypes.LaunchSequenceStepFragment;
  stepStatus: LaunchSequenceStepStatus;
};

export const LaunchStepProgressBar = ({ step, stepStatus }: Props) => (
  <div className="mr-3 mt-2 flex flex-col items-center self-stretch">
    {/* Icon */}
    <div className="mb-1.5 flex items-center justify-center">
      <LaunchEntryStatusIcon status={stepStatus} className="size-4" />
    </div>
    {/* Vertical Bar */}
    <div
      className={classnames('h-full w-0 border border-primary', {
        'border-dashed': stepStatus === LaunchSequenceStepStatus.INTIATED,
        'border-none': step.__typename === 'LaunchSequenceInitiatedStep',
      })}
    />
  </div>
);
